import * as actionTypes from "../../constants/actionTypes";
import { getPhoneState, getPhoneStates } from "../../api/phoneState";

const invalidatePhoneStates = () => {
  return {
    type: actionTypes.INVALIDATE_PHONE_STATES_DATA
  };
};

const loadPhoneState = (clientConfig, phoneStateId) => {
  return {
    type: actionTypes.LOAD_PHONE_STATE_DATA,
    promise: getPhoneState(clientConfig, phoneStateId)
  };
};

const loadPhoneStates = (clientConfig, dataStatus) => {
  return {
    type: actionTypes.LOAD_PHONE_STATES_DATA,
    promise: getPhoneStates(clientConfig, dataStatus)
  };
};

export { invalidatePhoneStates, loadPhoneState, loadPhoneStates };
